import axios from 'axios'
import { toast } from 'react-toastify'

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
})

API.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

API.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // App boot refresh — clear session quietly, don't toast
    if (error?.config?.url?.includes('/User/refreshtoken')) {
      error.data = {}
      return error
    }

    let errorMessage = ''
    const status = error?.response?.status
    if (status === 500) {
      errorMessage = 'Server error. Please try again later.'
    } else if (status === 400 || status === 415) {
      return error?.response
    } else if (status === 403) {
      errorMessage = 'Forbidden. You do not have permission to access this resource.'
    } else {
      errorMessage = 'We are unable to process your request at this time.'
    }
    toast.error(errorMessage, {
      style: {
        maxWidth: '100%',
        width: 'auto',
      },
    })

    error.data = {}
    return error
  },
)

export default API
